const agencies = [
    {
        id: 1,
        since: "2013",
        img: "assets/images/brands/microsoft.png",
        imgalt: "microsoft.png",
        name: "Microsoft",
        location: "Brasília, Brazil",
        property: "7620",
        employee: "36",
        email: "microsoft@steex.com",
        contact: "(33) 3521-6761"
    }, {
        id: 2,
        since: "2001",
        img: "assets/images/brands/mail_chimp.png",
        imgalt: "mail_chimp.png",
        name: "Mail Chimp",
        location: "California, USA",
        property: "1095",
        employee: "10",
        email: "mail_chimp@steex.com",
        contact: "(53) 3035-3100"
    }, {
        id: 3,
        since: "1998",
        img: "assets/images/companies/img-5.png",
        imgalt: "img-5.png",
        name: "Themesbrand",
        location: "Sobrado, Spain",
        property: "953",
        employee: "17",
        email: "themesbrand@steex.com",
        contact: "(21) 2345-6789"
    }, {
        id: 4,
        since: "1983",
        img: "assets/images/companies/img-7.png",
        imgalt: "img-7.png",
        name: "",
        location: "San Luis Potosi, Mexico",
        property: "3248",
        employee: "50",
        email: "pichhub@steex.com",
        contact: "(11) 3666-9716"
    }, {
        id: 5,
        since: "2009",
        img: "assets/images/companies/img-6.png",
        imgalt: "img-6.png",
        name: "Rotic Fashion",
        location: "Ibiza, Spain",
        property: "4985",
        employee: "55",
        email: "rotic@steex.com",
        contact: "(92) 3639-8685"
    }, {
        id: 6,
        since: "2012",
        img: "assets/images/companies/img-3.png",
        imgalt: "img-3.png",
        name: "Terry & Jerry",
        location: "Guarulhos, Brazil",
        property: "3214",
        employee: "64",
        email: "terry@steex.com",
        contact: "(11) 3885-1022"
    }, {
        id: 7,
        since: "2004",
        img: "assets/images/companies/img-2.png",
        imgalt: "img-2.png",
        name: "Brand Infosys",
        location: "California, USA",
        property: "1095",
        employee: "10",
        email: "brand_infosys@steex.com",
        contact: "(53) 3035-3100"
    }, {
        id: 8,
        since: "1996",
        img: "assets/images/companies/img-1.png",
        imgalt: "img-1.png",
        name: "Pich Fashion",
        location: "Natal, Brazil",
        property: "1258",
        employee: "37",
        email: "pichfashion@steex.com",
        contact: "(51) 3233-7909"
    }, {
        id: 9,
        since: "1994",
        img: "assets/images/brands/dribbble.png",
        imgalt: "dribbble.png",
        name: "Dribbble",
        location: "Hamburg, Germany",
        property: "1023",
        employee: "49",
        email: "dribbble@steex.com",
        contact: "(27) 3041-1766"
    }, {
        id: 10,
        since: "1980",
        img: "assets/images/brands/github.png",
        imgalt: "github.png",
        name: "GitHub",
        location: "Birmingham, United Kingdom",
        property: "954",
        employee: "32",
        email: "github@steex.com",
        contact: "(86) 9985-9220"
    }, {
        id: 11,
        since: "2009",
        img: "assets/images/companies/img-6.png",
        imgalt: "img-6.png",
        name: "Rotic Fashion",
        location: "Ibiza, Spain",
        property: "4985",
        employee: "55",
        email: "rotic@steex.com",
        contact: "(92) 3639-8685"
    }
];

export { agencies };